import { uploadService } from '../../services/UploadService';
const state = {
    files: [],
    loading: false,
    error: null,
};
const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_FILES(state, files) {
        state.files = files;
    },
    ADD_FILES(state, files) {
        state.files.push(...files);
    },
    REMOVE_FILE(state, fileId) {
        state.files = state.files.filter((file) => file.id !== fileId);
    },
};
const actions = {
    async uploadFiles({ commit }, { rmaId, files }) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            const response = await uploadService.uploadFiles(rmaId, files);
            // assume backend returns uploaded files list
            commit('ADD_FILES', response.data.files || []);
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to upload files');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async getFile({ commit }, fileId) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            return await uploadService.getFile(fileId);
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to fetch file');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async deleteFile({ commit }, fileId) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            await uploadService.deleteFile(fileId);
            commit('REMOVE_FILE', fileId);
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to delete file');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
};
const getters = {
    files: (state) => state.files,
    loading: (state) => state.loading,
    error: (state) => state.error,
};
const upload = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
export default upload;
